/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    stroke="currentColor"
    d="M4.8 5.2994h.5V2.3997C5.3 1.3603 6.1603.5 7.2.5h9.6c1.0397 0 1.9.8603 1.9 1.8997v2.8997h2.9c1.0397 0 1.9.8603 1.9 1.8997v9.5987c0 1.0394-.8603 1.8997-1.9 1.8997h-2.8984v2.8997c0 1.0394-.8635 1.9028-1.9032 1.9028H7.2016c-1.0397 0-1.9032-.8634-1.9032-1.9028v-2.8997H2.4c-1.0397 0-1.9-.8603-1.9-1.8997V7.1991c0-1.0394.8603-1.8997 1.9-1.8997h2.4Zm12.8 0h.5V2.3997c0-.7332-.5669-1.3-1.3-1.3H7.2c-.7331 0-1.3.5668-1.3 1.3v2.8997h11.7ZM4.7984 18.0977h.5v-4.5013a.3.3 0 0 1 .3013-.2981H18.4003a.3001.3001 0 0 1 .3013.2981v4.5013H21.6c.7331 0 1.3-.5667 1.3-1.2999V7.1991c0-.7332-.5669-1.3-1.3-1.3H2.4c-.7331 0-1.3.5668-1.3 1.3v9.5987c0 .7332.5669 1.2999 1.3 1.2999h2.3984Zm13.3032-3.6996v-.5H5.8984v7.6991c0 .7331.57 1.303 1.3032 1.303h9.5968c.7332 0 1.3032-.5699 1.3032-1.303v-7.1991ZM5.9 8.7989a.2999.2999 0 0 1-.5122.212A.2999.2999 0 0 1 5.6 8.499a.3.3 0 0 1 .3.2999Z"
  />,
  'Print'
);
